export default class Step {
    id = null
    title = null
    isComplete = null

    constructor({ id = null, title = null, isComplete = null }) {
        this.id = id
        this.title = title
        this.isComplete = isComplete
    }

}
